import BHowProtection from './BHowProtection'

export default BHowProtection
